import { customAxios } from '../../common/customAxios';

interface IPostVirtualNumberParams {
  productId: string;
  productCode: string;
  realNumber: string;
}

interface IPostVirtualNumberResponse {
  virtualNumber: string;
}

export const postVirtualNumber = ({
  productId,
  productCode,
  realNumber,
}: IPostVirtualNumberParams): Promise<IPostVirtualNumberResponse> => {
  return customAxios.post('/virtual-number', {
    productId,
    productCode,
    realNumber,
  });
};
